import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import Toastify from 'toastify-js';
import { Helmet } from "react-helmet-async";
import Swal from "sweetalert2";

const RefMapel = () => {
    const [kelas, setKelas] = useState([]);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        id_mapel: "",
        initial: "",
        nama_mapel: "",
        jenis_mapel: "Umum"
    });
    const [isEditing, setIsEditing] = useState(false);

    const fetchKelas = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getmapel`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }
            const data = await response.json();
            setKelas(data.data);
        } catch (error) {
            setError(error.message || 'Something went wrong');
        }
    }, []);

    useEffect(() => {
        fetchKelas();
    }, [fetchKelas]);

   

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputmapel`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || "Gagal menyimpan data");
            }

            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });
        } catch (error) {
            Swal.fire("Error!", error.message || 'Terjadi kesalahan', "error");
                       setError(error.message || 'Terjadi kesalahan');
            setError(error.message || 'Something went wrong');
        }
    };

    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };

    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            id_mapel: "",
            initial: "",
            nama_mapel: "",
            jenis_mapel: "Umum"
        });
    }; 
    useEffect(() => {
        if ($.fn.dataTable.isDataTable('.table')) {
            $('.table').DataTable().destroy();
        }
       
        $('.table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getmapel`,
                type: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
                dataSrc: function(json) {
                    if (!json.data || json.data.length === 0) {
                        return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                    }
                    return json.data;
                }
            },
            columns: [
                { 
                    data: null, 
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<small>${data.initial}</small><br/><b>${data.nama_mapel}</b>`;
                    }
                },
                { data: "jumlah_pendidik" },
                { 
                    data: null,
                    render: function (data, type, row) {
                        setKelas(row)
                        return `
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
                                <i class="ti ti-edit f-20"></i>
                            </a>
                            <a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.id_mapel}">
                                <i class="ti ti-trash f-20"></i>
                            </a>
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });
     
        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []);
    

    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapusmapel`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify({ id_mapel: id })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                        $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                    } else {
                        Swal.fire("Gagal!", data.message, "error");
                    }
                })
                .catch(error => {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                });
            }
        });
    });

    return (<>
        <Helmet>
            <title>Mata Pelajaran Griya Vidya</title>
        </Helmet>
        <div className="pc-container">
            <div className="pc-content">
                <div className="row">
                    <div className="col-xl-12 col-md-12">
                        <div className="card">

                            <div className="card-body">
                                <div className='row mb-3 align-items-center'>
                                    <div className="col"><small className="text-muted">Refrensi</small><h3>Mapel / Mata Pelajaran</h3></div>

                                    <div className='col-auto'>
                                        <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button></div>
                                </div>
                                <hr />
                                {/* Tabel kelas */}
                                <table className="table table-hover datatable-table">
                                    <thead>
                                        <tr>
                                            <th width="50">#</th>
                                            <th scope="col">Mapel / Mata Pelajaran</th>
                                            <th width="50"><center>Jumlah Guru</center></th>
                                            <th width="50"><center>Action</center></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      
                                    </tbody>
                                </table>
                                {/* Tampilkan error jika ada */}
                                {error && <div className="alert alert-danger">{error}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Modal Input/Edit */}
        <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <form onSubmit={handleSubmit} className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{isEditing ? "Edit Kelas" : "Tambah Kelas"}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">Initial</label>
                            <input type="text" className="form-control" name="initial" value={formData.initial} onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Nama Mapel</label>
                            <input type="text" className="form-control" name="nama_mapel" value={formData.nama_mapel} onChange={handleChange} required />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Tingkat Kelas</label>
                            <select name='jenis_mapel' className="form-select" value={formData.jenis_mapel} onChange={handleChange} required>
                                <option >Umum</option>
                                <option >Pilihan</option>
                                <option >Extrakurikuler</option>
                            </select>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                            Batal
                        </button>
                        <button type="onSubmit" className="btn btn-primary" data-bs-dismiss="modal">
                            {isEditing ? "Update" : "Simpan"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </>
    );
};

export default RefMapel;
